import isDefined from '@framework/data-helpers/isDefined';
import isServer from '@framework/router/Next/isServer';
import { getTrackingIdGoogleTagManager } from '@framework/browser/analytics/google/helpers';
import type { TNonce } from '@framework/router/Next/headers/ContentSecurityPolicyHeader/TNonce';

declare global {
  interface Window {
    dataLayer: Array<Record<string, any>>,
  }
}

const initGoogleTagManager = (nonce: TNonce = '') => {
  const trackingId = getTrackingIdGoogleTagManager();

  if (isDefined(trackingId) && !isServer()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const openComment = document.createComment('Google Tag Manager');
    const closeComment = document.createComment('End Google Tag Manager');
    const script = document.createElement('script');

    script.src = `https://www.googletagmanager.com/gtm.js?id=${ trackingId }`;
    script.async = true;
    if (nonce) {
      script.setAttribute('nonce', nonce);
    }

    document.head.insertBefore(script, document.head.firstChild);
    document.head.insertBefore(openComment, document.head.firstChild);
    script.parentNode!.insertBefore(closeComment, script.nextSibling);
  }
};

export default initGoogleTagManager;
